import { removeDuplicate } from 'src/app/controls/functions/shared-functions';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { RegistrationOtpComponent } from './registration-otp/registration-otp.component';
import { SuccessModalComponent } from './../../shared/success-modal/success-modal.component';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { getInvalidFieldsV2, jsonDeepParse, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { TranslateService } from '@ngx-translate/core';
import { jsonParse } from 'src/app/app.component';
import { Session } from 'src/app/classes/session/session';
import { SessionService } from 'src/app/services/session/session.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';
import { environment } from 'src/environments/environment';
import { JobseekerRegistrationService } from './../services/registration/jobseeker-registration.service';
import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy, NgZone, ElementRef, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { onlyAlphabets, email_pattern } from 'src/app/filters/filters.pipe';
import { AddResumeSkillsComponent } from './add-resume-skills/add-resume-skills.component';
import { ConfirmationComponent } from '../../shared/confirmation/confirmation.component';
import { markFormGroupTouched } from 'src/app/controls/components/dynamic-form/dynamic-form.component';
import { StarRatingColor } from 'src/app/controls/components/rating/rating.component';
import { CommunicationGuidelineComponent } from '../modals/communication-guideline/communication-guideline.component';
import { GuidelinesComponent } from '../modals/guidelines/guidelines.component';
import { getInvalidFields, viewDocument } from 'src/app/controls/functions/functions';
import { ActivatedRoute, Router } from '@angular/router';
import { StepperOrientation } from '@angular/cdk/stepper';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { SkillRatingComponent } from 'src/app/controls/components/skill-rating/skill-rating.component';
import { MatStepper } from '@angular/material/stepper';
import { LoginComponentV2 } from '../../login-v2/login.component';
import { WorkExperienceComponent } from './work-experience/work-experience.component';
import { DrivingLicenseComponent } from './driving-license/driving-license.component';
import { EmergencyContactsComponent } from './emergency-contacts/emergency-contacts.component';
import { ResumeNomineeComponent } from './resume-nominee/resume-nominee.component';
import { BankDetailsComponent } from './bank-details/bank-details.component';
import { CvMapComponent } from 'src/app/controls/components/cv-location/cv-map/cv-map.component';
import { LanguageListComponent } from './language-list/language-list.component';
import { CvLocationComponent } from 'src/app/controls/components/cv-location/cv-location/cv-location.component';
export const input_pdf_docs_only = "application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"

@Component({
  selector: 'app-jobseeker-registration',
  templateUrl: './jobseeker-registration.component.html',
  styleUrls: ['./jobseeker-registration.component.scss'],
  providers: [JobseekerRegistrationService, FilesService]
})
export class JobseekerRegistrationComponent implements OnInit, OnDestroy {
  @Input() all_rights: any = {};
  master_data: any = {}
  countryList = [];

  isLinear = true;
  stepper_list = [{
    id: 1,
    title: "Personal Information",
    active: 1,
    disabled: 0,
  }, {
    id: 2,
    title: "Preferences, Skills and Education",
    active: 0,
    disabled: 1,

  }, {
    id: 3,
    title: "Employment and Rating",
    active: 0,
    disabled: 1,

  },
    // {
    //   id: 4,
    //   title: "Employment and Rating",
    //   active: 0,
    //   disabled: 0,
    // }
  ];
  steps = [0, 1, 0]
  masters: any = {
    educationLevelList: [
      {
        "id": 6,
        "title": "UG/Under Graduate or below",
        "isDefault": 0
      },
      {
        "id": 7,
        "title": "PG/Post Graduate/Certified(Chartered)",
        "isDefault": 0
      },
      {
        "id": 8,
        "title": "PhD/Doctoral",
        "isDefault": 0
      }
    ]
  }
  registration = {
    registration_mobile_length: 10,
    mobile_number_length: 10,
    alt_mobile_number_length: 10,
    key_skills: []
  };
  email_pattern = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$";
  crDate = new Date();
  starCount: number = 5;
  commRatingLevels_masters = [];
  starColor: StarRatingColor = StarRatingColor.accent;
  current_preferred_location;
  stepperOrientation;
  checkFormValidation = 0;
  registrationForm = new UntypedFormGroup({
    cvPath: new UntypedFormControl(null),
    jobType: new UntypedFormControl(null),
    firstName: new UntypedFormControl(null, [Validators.pattern(onlyAlphabets)]),
    lastName: new UntypedFormControl(null, [Validators.pattern(onlyAlphabets)]),
    mobileNumber: new UntypedFormControl(null),
    mobileIsd: new UntypedFormControl(null),
    emailId: new UntypedFormControl(null, [Validators.pattern(email_pattern)]),
    address: new UntypedFormControl(null),
    profilePicture: new UntypedFormControl(null),
    isJobseeker: new UntypedFormControl(1),
    sellerShortCode: new UntypedFormControl(environment.SHORTCODE),
    cvFileName: new UntypedFormControl(null),
    resId: new UntypedFormControl(0),
    password: new UntypedFormControl(null, [Validators.minLength(6), Validators.pattern(/(?=.*\W)(?=.*\d)/)]),
    confirmPassword: new UntypedFormControl(null),
    ip: new UntypedFormControl(getIP().ip),
    latitude: new UntypedFormControl(null),
    longitude: new UntypedFormControl(null),
    referralCode: new UntypedFormControl(null),
    waMobileIsd: new UntypedFormControl(''),
    waMobileNumber: new UntypedFormControl(''),
    presentLocationId: new UntypedFormControl(null),
    otp: new UntypedFormControl(null),
    skillType: new FormControl(null)


  }, this.checkPassword);
  valid_captcha

  valid_captcha_flag = false;
  @ViewChild('recaptcha', { static: true }) captch_element: ElementRef;

  fileType = input_pdf_docs_only

  resumeBankForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.pattern(onlyAlphabets)]),
    middleName: new UntypedFormControl(null),
    lastName: new UntypedFormControl('', [Validators.pattern(onlyAlphabets)]),
    mobileNumber: new UntypedFormControl(''),
    mobileIsd: new UntypedFormControl(''),
    altMobileIsd: new UntypedFormControl(),
    altMobileNumber: new UntypedFormControl(''),
    altEmailId: new UntypedFormControl(''),
    waMobileIsd: new UntypedFormControl(''),
    waMobileNumber: new UntypedFormControl(''),
    genderCode: new UntypedFormControl(null),
    emailId: new UntypedFormControl('', [Validators.pattern(this.email_pattern)]),
    ppNumber: new UntypedFormControl(null),
    ppIssueDate: new UntypedFormControl(null),
    ppExpiryDate: new UntypedFormControl(null),
    dob: new UntypedFormControl(),
    resumeStatusCode: new UntypedFormControl(0),
    interestedAfterDate: new UntypedFormControl(new Date()),
    presentLocation: new UntypedFormControl(null),
    presentLocationId: new UntypedFormControl(null),
    latitude: new UntypedFormControl(null),
    longitude: new UntypedFormControl(null),
    resId: new UntypedFormControl(0),
    restrictDirectSubmission: new UntypedFormControl(),
    countryCode: new UntypedFormControl(''),
    cvType: new UntypedFormControl(1),
    source: new UntypedFormControl(null),
    sourceRef: new UntypedFormControl(null),
    totalExp: new UntypedFormControl(0),
    experienceId: new UntypedFormControl(null),
    anyKeywords: new UntypedFormControl(''),
    presentEmployer: new UntypedFormControl(''),
    designation: new UntypedFormControl('', Validators.maxLength(100)),
    jobTitleId: new UntypedFormControl('', Validators.maxLength(100)),
    noticePeriod: new UntypedFormControl(30),
    noticePeriodId: new UntypedFormControl(null),
    presentSalaryValueMapId: new UntypedFormControl(null),
    expectedSalaryValueMapId: new UntypedFormControl(null),
    presentSalaryCurrId: new UntypedFormControl(),
    presentSalary: new UntypedFormControl(0,),
    presentSalaryScaleDurationId: new UntypedFormControl(null),
    netSalaryValueMapId: new UntypedFormControl(null),

    netSalaryCurrId: new UntypedFormControl(),
    netSalary: new UntypedFormControl(0,),

    netSalarySDTemplateCode: new UntypedFormControl(null),
    expSalaryCurrId: new UntypedFormControl(null),
    expSalary: new UntypedFormControl(0,),
    expSalaryScaleDurationId: new UntypedFormControl(1),
    declareResumeOwnership: new UntypedFormControl(null), // before saving when resId = 0
    jobType: new UntypedFormControl(null),
    // jobType: new FormArray([], minSelectedCheckboxes(0)),
    cvKeywords: new UntypedFormControl(''),
    cvPath: new UntypedFormControl(''),
    cvFileName: new UntypedFormControl(''),
    profilePicture: new UntypedFormControl(''),
    isEditable: new UntypedFormControl(1),
    industry: new UntypedFormControl(),
    certification: new UntypedFormControl(),
    // rating: new FormControl(),
    partnerId: new UntypedFormControl(''),
    linkPartner: new UntypedFormControl(0),
    keySkills: new UntypedFormControl(null),
    roles: new UntypedFormControl(),
    isIntJS: new UntypedFormControl(),
    isHeight: new UntypedFormControl(0),
    nationalityCode: new UntypedFormControl(),
    workPermits: new UntypedFormControl(),
    languages: new UntypedFormControl(null),
    heightCode: new UntypedFormControl(1),
    visionCode: new UntypedFormControl(1),
    bodyTypeCode: new UntypedFormControl(1),
    isVision: new UntypedFormControl(0),
    isBodyType: new UntypedFormControl(0),
    isPremiumRole: new UntypedFormControl(0),
    abilities: new UntypedFormControl(),
    isPhysicalChecked: new UntypedFormControl(1),
    productCode: new UntypedFormControl(null),
    fileName: new UntypedFormControl(null),
    consultants: new UntypedFormControl([]),
    cvSourceType: new UntypedFormControl(1),
    functionalArea: new UntypedFormControl(null),

    notes: new UntypedFormControl(null),
    clientCVFileName: new UntypedFormControl(null),
    clientCVPath: new UntypedFormControl(null),
    education: new UntypedFormControl(null),
    alertId: new UntypedFormControl(null),

    preferredLocationIds: new UntypedFormControl(null),
    preferredLocation: new UntypedFormControl(null),
    industryCodes: new UntypedFormControl(null),
    skillRankingList: new UntypedFormControl(null),
    employmentHistory: new UntypedFormControl(null),
    servingNP: new UntypedFormControl(null),
    lwd: new UntypedFormControl(null),
    isECR: new UntypedFormControl(0),
    resDeclaration: new UntypedFormControl(null),
    extendedData: new UntypedFormControl(null),
    extendedDataUI: new UntypedFormControl(null),
    maskedCV: new UntypedFormControl(null),
    clientCVTemplateId: new UntypedFormControl(null),
    isAltMobileNumberOnWA: new UntypedFormControl(null),
    isMobileNumberOnWA: new UntypedFormControl(null),

    linkedIn: new UntypedFormControl(null),
    facebook: new UntypedFormControl(null),
    instagram: new UntypedFormControl(null),
    twitter: new UntypedFormControl(null),
    weChat: new UntypedFormControl(null),
    sourceRefTitle: new UntypedFormControl(null),
    sourceTitle: new UntypedFormControl(null),


    languageData: new UntypedFormControl(null),
    visaData: new UntypedFormControl(null),
    certificationData: new UntypedFormControl(null),
    bankNameId: new UntypedFormControl(null),
    bankName: new UntypedFormControl(null),
    bankAddressLine1: new UntypedFormControl(null),
    bankAddressLine2: new UntypedFormControl(null),
    bankPostalCode: new UntypedFormControl(null),
    bankCityId: new UntypedFormControl(null),
    bankCityName: new UntypedFormControl(null),
    bankStateId: new UntypedFormControl(null),
    bankStateName: new UntypedFormControl(null),
    bankCountryId: new UntypedFormControl(null),
    bankRefCode: new UntypedFormControl(null),
    bankAccountNumber: new UntypedFormControl(null),
    bankAttachments: new UntypedFormControl(null),

    panCardNumber: new UntypedFormControl(null),
    panAttach: new UntypedFormControl(null),
    aadharNumber: new UntypedFormControl(null),
    aadharAttach: new UntypedFormControl(null),
    drivingLicense: new UntypedFormControl(null),
    presentAddress: new UntypedFormControl(null),
    permanentAddress: new UntypedFormControl(null),
    vaccinationStatus: new UntypedFormControl(null),
    vaccinationDate: new UntypedFormControl(null),
    PFNumber: new UntypedFormControl(''),
    UANNumber: new UntypedFormControl(''),
    ESINumber: new UntypedFormControl(''),
    martialStatus: new UntypedFormControl(null),
    bloodGroup: new UntypedFormControl(null),
    spouseName: new UntypedFormControl(null),
    personalEmailID: new UntypedFormControl(null),
    nomineeItems: new UntypedFormControl(null),

    emergencyContacts: new UntypedFormControl(null),
    pickUpPoint: new UntypedFormControl(null),
    marriageDate: new UntypedFormControl(null),
    fatherName: new UntypedFormControl(''),
    isSpeciallyAbled: new UntypedFormControl(0),
    speciallyAbled: new UntypedFormControl(null),
    specialAbledDesc: new UntypedFormControl(''),
    skillType: new FormControl(null)
  })

  Object = Object;
  validators = Validators;
  education_masters = {
    universityMaster: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
    universityList1: [],
    universityList2: [],
    universityList3: [],
    collegeMaster: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
    collegeList1: [],
    collegeList2: [],
    collegeList3: [],


  }

  presentAddressForm: UntypedFormGroup = new UntypedFormGroup({
    "cityId": new UntypedFormControl(null),
    "status": new UntypedFormControl(null),
    "stateId": new UntypedFormControl(null),
    "cityName": new UntypedFormControl(null),
    "latitude": new UntypedFormControl(null),
    "countryId": new UntypedFormControl(null),
    "longitude": new UntypedFormControl(null),
    "stateName": new UntypedFormControl(null),
    "postalCode": new UntypedFormControl(null),
    "attachments": new UntypedFormControl(null),
    "countryName": new UntypedFormControl(null),
    "addressLine1": new UntypedFormControl(null),
    "addressLine2": new UntypedFormControl(null),
  })

  permanentAddressForm: UntypedFormGroup = new UntypedFormGroup({
    "cityId": new UntypedFormControl(null),
    "status": new UntypedFormControl(null),
    "stateId": new UntypedFormControl(null),
    "cityName": new UntypedFormControl(null),
    "latitude": new UntypedFormControl(null),
    "countryId": new UntypedFormControl(null),
    "longitude": new UntypedFormControl(null),
    "stateName": new UntypedFormControl(null),
    "postalCode": new UntypedFormControl(null),
    "attachments": new UntypedFormControl(null),
    "countryName": new UntypedFormControl(null),
    "addressLine1": new UntypedFormControl(null),
    "addressLine2": new UntypedFormControl(null),
  })
  session_obj: Session = new Session()

  jobseeker = {
    registration_prev_obj: null,
    is_misd_disabled: false,
    mobile_number_length: 15,
    alt_mobile_number_length: 15,
    registration_mobile_length: 15,
    partner_id: 0,
    partner_name: '',
    partnerFound: false,
    partnerNotFound: false,
    userDetails: null,
    show_partner_flag: false,
    user_session_info: null,
    is_new_partner: true,
    submitPanelFlag: false,
    cv_url: '',
    hide: true,
    valid_consultant: false,
    consultants: [],
    backup_consultant: null,
    pdf: null,
    image: null,
    url: null,
    loading: false,
    files: [],
    cvSourceList: [],
    cvTypeList: [],
    myFlagForButtonToggleMultiple: [],
    current_education: {
      isPassing: 0,
      isSpecialization: 0,
      isPercentage: 0,
      noSpecialization: 0,
    },
    getting_data: false,
    default_form_group_data: null,
    job_type_list: [],
    file_data: null,
    current_status_obj: {
      resumeStatusCode: 0
    },
    current_tab_details: null,
    current_res_id: 0,
    default_cv_types: [],
    current_cv_types: [],
    extended_info: [],
    tagList: [],
    profileHeight: 120,
    profileWidth: 125,
    cv_log_list: [],
    attachmentUploadStatus: 0,
    communication_history: [],
    sourceList: [],
    notes: [],
    currentLocation: null,
    activeTab: null,
    activeTabVertical: null,
    active: 2,
    isDetailsCollapse: false,
    isDocumentCollapse: false,
    show_req_history: false,
    current_applicant_index: 0,
    current_present_salary: null,
    current_net_salary: null,

    current_expected_salary: null,
    current_notice_period: null,
    current_experience: null,
    sellerCode: null,
    clientCVLogList: [],
    clientCVTemplateList: [],
    field_config_access_list: [],
    skillMasters: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
    selected_skills: [],
    no_data_found_message: 'Type to search',
    selected_jobtitle: [],
    jobTitleMasters: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
    jobTitleList: [],
  };
  readonlySpecialization: boolean;
  country_info: any = {}
  field_text_type: boolean;
  field_text_type1: boolean;
  password_field_text_type: boolean;
  phoneNumber_field_text_type: boolean;
  cv_rating: any;
  cv_rating_title: any;
  comm_rating: any;
  comm_rating_title: any;
  resId = 0;
  lat = 0;
  lang = 0;
  cvAttachments = []
  geo_decoder: google.maps.Geocoder;
  editable: boolean = false;
  openSkillRankingRef: Function;
  @ViewChild('stepper') stepper: MatStepper;
  profileCaptureStarted: boolean;
  random_width = []

  resumeObj: any = {};
  uploadedImageUrl: string | ArrayBuffer;
  isValidCode: boolean = false;
  field_loading: boolean = true;
  referral_code = {
    isVerify: false,
    isValid: false,
    displayName: null,
    referralCode: null,
    message: null
  }
  timeBasedMaster = {
    cityList: [],
    stateList: [],
    locationList: []
  }
  startAt = new Date();
  minValue = new Date()

  copyMobileNumberToWARef: Function
  companySettingsSettings: any;
  addSkillRef: Function;
  valid_education: any;
  educationLevel1 = [];
  educationLevel2 = [];
  educationLevel3 = [];
  current_education: any = {};
  current_education2: any = {};
  current_education3: any = {};
  current_percentage_type: any = {};
  current_percentage_type2: any = {};
  current_percentage_type3: any = {};
  educationForm: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl('',),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(6),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),


  })
  educationForm2: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl(''),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(7),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  educationForm3: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl(''),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(8),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  educationList = [];
  field_config_access: any = {};
  currentIndex = 0;
  today = new Date();
  key_skills_masters = {
    roles: [],
    skills: []
  };
  queryParams: any;
  requirement_details: any = {};
  resume_details: any = {};
  original_field_config_access: any = {};
  managePresentLocationsRef: Function;
  manageLocationsRef: Function;
  secondTabFormGroup: FormGroup = new FormGroup({
    keySkills: new FormControl(null),
    anyKeywords: new FormControl(null),
    preferredLocationIds: new FormControl(null)
  })

  // this.field_config_access['RES_password']?.validationScriptUI?.mandatory
  passValidation = {
    minLength: 6,
  }

  constructor(
    private dialog: MatDialog,
    private registration_srv: JobseekerRegistrationService,
    public change_detector: ChangeDetectorRef,
    private notification_srv: NotificationService,
    private session: SessionService,
    private translate: TranslateService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private file_service: FilesService,
    private activated_router: ActivatedRoute,
    private profile_settings: ProfileSettingsService
  ) {
    this.today.setDate(this.today.getDate());
    this.geo_decoder = new google.maps.Geocoder;
    // this.loadCountryCodeMaster();
    // this.stepperOrientation = breakpointObserver.observe('(min-width: 800px)')
    //   .pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
    for (let i = 0; i < 6; i++) {
      this.random_width[i] = [];
      for (let j = 0; j < 2; j++) {
        this.random_width[i][j] = this.randomNumber() + 'px';
      }
    }
    console.log(this.random_width)
  }

  ngOnInit() {
    console.log(this.activated_router.snapshot.queryParams)
    this.queryParams = this.activated_router.snapshot.queryParams;
    this.managePresentLocationsRef = this.managePresentLocations.bind(this);
    this.manageLocationsRef = this.manageLocations.bind(this)

    this.profile_settings.loadDefaultSettings().subscribe(res => {
      console.log(res)
      if (res && res['data']) {
        this.country_info = res['data'];
        if (res['data'].companySettingsJson) {
          this.companySettingsSettings = jsonDeepParse(res['data'].companySettingsJson);
          console.log(this.companySettingsSettings);
        }
        if (this.country_info && this.country_info.jobTypeList && this.country_info.jobTypeList.length) {
          this.registrationForm.controls.jobType.patchValue(this.country_info.jobTypeList.filter(data => data.isChecked).map(d => d.jobType))
        }
        this.registrationForm.controls.mobileIsd.patchValue(res['data'].defaultISD)
        if (res && res['data'].fieldConfigFlags) {
          res['data'].fieldConfigFlags = jsonDeepParse(res['data'].fieldConfigFlags);
          this.all_rights = jsonDeepParse(res['data'])
        }
        if (!res['isSession']) {
          if (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.job) {
            let req: any = Object.assign({}, this.queryParams);
            req['productCode'] = this.activated_router.snapshot.queryParams.job;
            this.getJobDetails(req)
          }
          else {
            this.setDefaultRights();
            console.log(this.field_config_access)
            this.field_loading = false;
            try {
              let id = sessionStorage.getItem('resId')
              if (id && parseInt(id) > 0) {
                this.resId = parseInt(id);
                this.loadResumeWithMasters(parseInt(id));
                this.stepper_list.forEach(data => {
                  data.disabled = 0;
                })
                this.active(this.stepper_list[0]);
                this.registrationForm.controls.password.clearValidators();
                this.registrationForm.controls.password.updateValueAndValidity();
                this.registrationForm.controls.confirmPassword.clearValidators();
                this.registrationForm.controls.confirmPassword.updateValueAndValidity();

              }
              else {
                this.resId = 0;
                this.addRecaptchaScript()
              }
            }
            catch (err) {
              this.loadResumeWithMasters(0);
            }
          }
        }


      }
    })
    this.startAt.setFullYear(this.startAt.getFullYear() - 15)
    this.minValue.setFullYear(this.minValue.getFullYear() - 60)
    this.copyMobileNumberToWARef = this.copyMobileNumberToWA.bind(this)
    this.openSkillRankingRef = this.openSkillRanking.bind(this)
    this.addSkillRef = this.openSkillBottomSheet.bind(this)
    this.onCandidateRatingChanged(1);
    this.commRating(1);
    this.profile_settings.searchMasterWithTimestamp({
      "startPage": 1,
      "limit": 1000,
      "search": "",
      "lastTimeStamp": null
    }, 'get_city_list', 'cityList', 'id').subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        this.timeBasedMaster.cityList = res['data'].list.filter(data => data.type == 1)
        this.timeBasedMaster.locationList = res['data'].list;

      }

    });
    this.stepperOrientation = window.innerWidth < 900 ? 'vertical' : 'horizontal'
    // try {
    //   let referralCode = this.activated_router.snapshot.params.id;
    //   this.registrationForm.controls.referralCode.patchValue(referralCode);
    //   if (this.registrationForm.controls.referralCode.value && this.registrationForm.controls.referralCode.value != '')
    //     this.applyReferralCode();
    // }
    // catch (err) {

    // }

    // this.getCurrentLocation();
    if (this.router.url == '/edit-profile') {
      this.editable = true;
    }







    let h = window.innerHeight
    let w = window.innerWidth;
    let ratio;

    if (w <= 1024) {
      ratio = h / w * 200;
    }
    else if (w <= 1229) {
      ratio = h / w * 260;
    }
    else if (w >= 1500) {
      ratio = h / w * 300;
    }
    else {
      ratio = h / w * 280;
    }
    this.jobseeker.profileHeight = ratio;
    this.jobseeker.profileWidth = ratio;
  }
  presentLocationChanged(ev) {
    if (ev) {
      this.resumeBankForm.patchValue({
        latitude: ev.latitude,
        longitude: ev.longitude
      })
    }
  }
  industryChanged(ev) {
    console.log(ev)
    this.resumeBankForm.controls.industry.patchValue(ev)
  }
  getJobDetails(req) {

    this.registration_srv.getJobs(req).subscribe((res) => {
      if (res && res['data']) {
        if (res['data'].detail) {
          this.requirement_details = jsonDeepParse(res['data'].detail);

          if (this.requirement_details && this.requirement_details.fieldConfigTemplateList && this.requirement_details.fieldConfigTemplateList.length) {
            prepareFieldConfigFlagsNew(this.requirement_details.fieldConfigTemplateList, this.educationForm, null, "RES_");
            prepareFieldConfigFlagsNew(this.requirement_details.fieldConfigTemplateList, this.educationForm2, null, "RES_");
            prepareFieldConfigFlagsNew(this.requirement_details.fieldConfigTemplateList, this.educationForm3, null, "RES_");
            prepareFieldConfigFlagsNew(this.requirement_details.fieldConfigTemplateList, this.secondTabFormGroup, null, "RES_");
            this.field_config_access = prepareFieldConfigFlagsNew(this.requirement_details.fieldConfigTemplateList, this.resumeBankForm, this.registrationForm, "RES_");
            this.original_field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");



            setTimeout(() => {
              this.addRecaptchaScript()
            }, 200)
          }
          else {
            this.setDefaultRights();
          }
          this.field_loading = false;
          try {
            let id = sessionStorage.getItem('resId')
            if (id && parseInt(id) > 0) {
              this.resId = parseInt(id);
              this.loadResumeWithMasters(parseInt(id));
              this.stepper_list.forEach(data => {
                data.disabled = 0;
              })
              this.active(this.stepper_list[0]);
              this.registrationForm.controls.password.clearValidators();
              this.registrationForm.controls.password.updateValueAndValidity();
              this.registrationForm.controls.confirmPassword.clearValidators();
              this.registrationForm.controls.confirmPassword.updateValueAndValidity();

            }
            else {
              this.resId = 0;
              this.addRecaptchaScript()
            }
          }
          catch (err) {
            this.loadResumeWithMasters(0);
          }
        }
        else {
          this.requirement_details = {}
          this.field_loading = false;
          this.setDefaultRights();

          setTimeout(() => {
            this.addRecaptchaScript()
          }, 200)
        }
      }
    }, err => {
      this.field_loading = false;
      this.setDefaultRights();
    })
  }


  setDefaultRights() {
    if (this.all_rights && !this.field_config_access || (this.field_config_access && Object.keys(this.field_config_access).length == 0)) {
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.educationForm, null, "RES_");
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.educationForm2, null, "RES_");
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.educationForm3, null, "RES_");
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.presentAddressForm, null, "RESADD_");
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.permanentAddressForm, null, "RESADD_");
      prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.secondTabFormGroup, null, "RES_");

      this.field_config_access = prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");
      this.original_field_config_access = prepareFieldConfigFlagsNew(this.all_rights.fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");
    }
  }
  getCurrentLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      console.log(position)
      this.registrationForm.controls.latitude.patchValue(position.coords.latitude)
      this.registrationForm.controls.longitude.patchValue(position.coords.longitude)
      this.lat = position.coords.latitude;
      this.lang = position.coords.longitude;
      this.geo_decoder.geocode({ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } }, (results, status) => {
        if (status === 'OK') {
          console.log(results)
          let complete_address = results[0].formatted_address;
          this.registrationForm.controls.address.patchValue(complete_address)
        }
        else {
          //  window.alert('Geocoder failed due to: ' + status);
        }
      });
    });
  }
  ngOnDestroy() {
    if (this.resumeBankForm.value.resId && this.resumeBankForm.value.resId > 0) {
      sessionStorage.setItem('resId', this.resumeBankForm.value.resId);
    }
  }

  checkPassword(group: UntypedFormGroup) {
    let newPass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value;
    if (newPass != confirmPass && confirmPass != '') {
      group.get('confirmPassword').setErrors({ notEqual: true });
    }
    if (newPass == confirmPass) {
      group.get('confirmPassword').clearValidators();
    }
    return newPass == confirmPass ? null : { notEqual: true }
  }

  loadCountryCodeMaster() {
    this.registration_srv.getMasters().subscribe(res => {
      if (res && res['data']) {
        this.country_info = res['data'];
        if (res['data'].companySettingsJson) {
          this.companySettingsSettings = jsonDeepParse(res['data'].companySettingsJson);
        }
        if (this.country_info && this.country_info.jobTypeList && this.country_info.jobTypeList.length) {
          this.registrationForm.controls.jobType.patchValue(this.country_info.jobTypeList.filter(data => data.isChecked).map(d => d.jobType))
        }
        this.registrationForm.controls.mobileIsd.patchValue(res['data'].defaultISD)
        if (res && res['data'].fieldConfigFlags) {
          res['data'].fieldConfigFlags = jsonDeepParse(res['data'].fieldConfigFlags);
        }
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm, null, "RES_");
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm2, null, "RES_");
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm3, null, "RES_");
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.secondTabFormGroup, null, "RES_");

        this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");
        this.original_field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");
      }
    })
  }
  current_selection: any;
  manageLocations(ev) {
    console.log(ev)
    this.dialog
      .open(CvLocationComponent, {
        width: '40%',
        data: this.current_selection || {},
        height: 'fit-content'
      }).afterClosed().subscribe(res => {
        if (res) {
          this.current_selection = res;
          if (res && res.id) {
            this.profile_settings.searchMasterWithTimestamp({
              "startPage": 1,
              "limit": 1000,
              "search": "",
              "lastTimeStamp": null
            }, 'get_city_list', 'cityList', 'id').subscribe(res => {
              if (res && res['data'] && res['data'].list) {
                this.timeBasedMaster.cityList = res['data'].list.filter(data => data.type == 1)
                this.timeBasedMaster.locationList = res['data'].list;
              }
            });
            let arr = this.resumeBankForm.controls.preferredLocationIds.value;

            if (arr && arr.length) {
              try {
                arr.push(parseInt(res.id));
              }
              catch (err) {
                arr.push(res.id);
                console.log(err)
              }
            }
            else {
              try {
                arr = parseInt(res.id);
              }
              catch (err) {
                arr = res.id;
                console.log(err)
              }
            }
            this.resumeBankForm.controls.preferredLocationIds.patchValue(arr)
          }
        }
      })
  }
  managePresentLocations(ev) {
    console.log(ev)
    if (ev && ev.type == 100) {
      this.openLocationMap()
    }
    else {
      this.dialog.open(CvLocationComponent, {
        width: '40%',
        data: this.current_selection || {},
        height: 'fit-content'
      }).afterClosed().subscribe(res => {
        if (res) {
          this.current_selection = res;
          if (res && res.id) {
            this.profile_settings.searchMasterWithTimestamp({
              "startPage": 1,
              "limit": 1000,
              "search": "",
              "lastTimeStamp": null
            }, 'get_city_list', 'cityList', 'id').subscribe(res => {
              if (res && res['data'] && res['data'].list) {
                this.timeBasedMaster.cityList = res['data'].list.filter(data => data.type == 1)
                this.timeBasedMaster.locationList = res['data'].list;
              }
            });
            this.registrationForm.controls.presentLocationId.patchValue(res.id)

          }
        }
      })
    }

  }


  openLocationMap() {
    this.dialog.open(CvMapComponent, {
      width: '50%',
      data: {
        latitude: this.resumeBankForm.value.latitude,
        longitude: this.resumeBankForm.value.longitude
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.resumeBankForm.controls.latitude.patchValue(res.latitude)
        this.resumeBankForm.controls.longitude.patchValue(res.longitude)
      }
    })
  }
  openSkillRanking() {
    this.dialog.open(SkillRatingComponent, {
      width: '60%',
      panelClass: 'TM-Dialog',
      data: {
        options: this.resumeBankForm.value.skillRankingList,
        type: 1
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        console.log(res)
        this.resumeBankForm.controls.skillRankingList.patchValue(res);
      }
    })
  }

  active(item, disable_item?) {
    if (item && !item.disabled) {
      this.stepper_list.forEach(i => {
        i.active = 0
      })
      item.active = 1;
    }
    if (disable_item) {
      disable_item.disabled = 1;
    }

  }
  mobileChange(ev, flag?) {

    if (flag == 1) { //registration seciton
      if (ev) {
        if (ev && ev.mobileNumberLength) {
          this.registration.registration_mobile_length = ev.mobileNumberLength || 15
        }
        else {
          this.registration.registration_mobile_length = 15
        }
      }
    }
    else if (flag == 2) { //personal section mobile number

      if (ev && ev.mobileNumberLength) {
        this.registration.mobile_number_length = ev.mobileNumberLength || 15;
        // if (!this.jobseeker.getting_data) {
        //   // this.resumeBankForm.controls.mobileNumber.reset();
        // }
        this.registrationForm.controls.mobileNumber.setValidators([Validators.minLength(ev.mobileNumberLength || 0), Validators.maxLength(this.registration.mobile_number_length)])
      }
      else {
        this.registration.mobile_number_length = 15
      }
    }
    else if (flag == 3) { //personal section alternative mobile number
      if (ev && ev.mobileNumberLength) {
        this.registration.alt_mobile_number_length = ev.mobileNumberLength || 15
      }
      else {
        this.registration.alt_mobile_number_length = 15
      }
    }



  }

  show_map = 1;
  interval;
  process_bar;
  pinterval;
  timer;
  google_search;
  @ViewChild('addresstext', { static: false }) addresstext: any;
  @ViewChild('addresstextPresent', { static: false }) addresstextPresent: any;

  setTimer() {
    this.show_map = 0;
    if (this.show_map != 1) {
      this.startTimer();
    }
    if (this.interval) {
      clearTimeout(this.interval);
    }
    this.interval = setTimeout(() => {
    }, 3000);
  }
  startTimer() {
    this.pinterval = setInterval(() => {
      if (this.process_bar < 90) {
        this.process_bar += 1;
      } else {
        this.process_bar = 0;
      }
    }, 1000)
  }
  pauseTimer() {
    clearInterval(this.pinterval);
  }
  getPlaceAutocompleteRefPresent = this.getPlaceAutocompletePresent.bind(this);

  private getPlaceAutocompletePresent() {
    if (this.addresstextPresent) {
      const autocomplete = new google.maps.places.Autocomplete(this.addresstextPresent.nativeElement,
        {
        });
      types: ['address']  // 'establishment' / 'address' / 'geocode'
      // google.maps.event.addListener()
      google.maps.event.addListener(autocomplete, "place_changed", (res) => {
        const address = String(autocomplete.getPlace().formatted_address);
        if (address) {
          this.registrationForm.controls.address.patchValue(address);
        }
        if (autocomplete.getPlace().geometry) {
          this.registrationForm.controls.latitude.patchValue(autocomplete.getPlace().geometry.location.lat());
          this.registrationForm.controls.longitude.patchValue(autocomplete.getPlace().geometry.location.lng());
        }
        else {

        }

      });
    }

  }

  // end present location
  getPlaceByAddress() {
    this.timer = 10;
    //
    if (this.addresstext) {
      const service = new google.maps.places.PlacesService(this.addresstext.nativeElement).findPlaceFromQuery({
        query: this.google_search,
        fields: ['name', 'geometry', 'formatted_address'],
      }, res => {
        //
        this.pauseTimer();
        this.process_bar = 0;
        if (res && res[0]) {


          let countryCode = res[0].address_components[(res[0].address_components.length - 2)].short_name
          // this.data.address = res[0].formatted_address;
          // this.zoom = 20;
          // this.addMarker(res[0].geometry.location.lat(), res[0].geometry.location.lng());
          // this.center= {
          //   lat :res[0].geometry.location.lat(),
          //   lng:res[0].geometry.location.lng(),
          // }
          // this.data.latitude = res[0].geometry.location.lat();
          // this.data.longitude= res[0].geometry.location.lng();
        }
        else {
        }
      });
    }

    // let timer = setTimeout(()=>{
    //   this.process_bar +=5;
    // },1000);
  }

  getPlaceAutocompleteRef = this.getPlaceAutocomplete.bind(this);

  private getPlaceAutocomplete() {
    try {
      if (this.addresstext) {
        const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
          {
          });
        types: ['address']  // 'establishment' / 'address' / 'geocode'
        // google.maps.event.addListener()
        google.maps.event.addListener(autocomplete, "place_changed", (res) => {
          const address = String(autocomplete.getPlace().formatted_address);
          if (autocomplete.getPlace().geometry) {
            this.current_preferred_location = {}
            this.current_preferred_location['latitude'] = autocomplete.getPlace().geometry.location.lat();
            this.current_preferred_location['longitude'] = autocomplete.getPlace().geometry.location.lng();
            this.current_preferred_location['prefLocation'] = address;


          }
          else {

            this.getPlaceByAddress();
          }
          //
          // this.invokeEvent(address);
        });
      }

    }
    catch (err) {

    }

  }
  findLocation() {

  }
  deleteLocation(data, index) {
    let loc = this.resumeBankForm.value.preferredLocation || []
    if (loc && loc.length) {
      loc.splice(index, 1)
      loc = [...loc] // render the mat table

    }

  }

  changeEducation(ev, type?) {
    if (!type) {
      this.current_education = ev;
      if (ev) {
        this.educationForm.controls.educationTitle.patchValue(ev.title)
        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm.controls.passingMN.setValidators([Validators.required])
            this.educationForm.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.passingMN.clearValidators();
            this.educationForm.controls.passingMN.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type && this.current_percentage_type.id) {
              if (this.current_percentage_type.maxVal) {
                validators.push(Validators.max(this.current_percentage_type.maxVal));
              }
              if (this.current_percentage_type.minVal) {
                validators.push(Validators.min(this.current_percentage_type.minVal));
              }
            }
            this.educationForm.controls.percentage.setValidators(validators);
            this.educationForm.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type && this.current_percentage_type.id) {
              if (this.current_percentage_type.maxVal) {
                validators.push(Validators.max(this.current_percentage_type.maxVal));
              }
              if (this.current_percentage_type.minVal) {
                validators.push(Validators.min(this.current_percentage_type.minVal));
              }
              this.educationForm.controls.percentage.setValidators(validators);
            }
            this.educationForm.controls.percentage.updateValueAndValidity();

          }
        }


        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.specializationCode.clearValidators();
            this.educationForm.controls.specializationCode.updateValueAndValidity();
          }
        }
        if (ev.noSpecialization) {
          this.educationForm.controls.specializationCode.clearValidators();
          this.educationForm.controls.specializationTitle.clearValidators();
          this.educationForm.controls.specializationTitle.patchValue(null)
          this.educationForm.controls.specializationCode.patchValue(null)
          this.educationForm.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm.controls.universityCode.setValidators([Validators.required]);
            this.educationForm.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.universityCode.clearValidators();
            this.educationForm.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm.controls.collegeId.setValidators([Validators.required]);
            this.educationForm.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.collegeId.clearValidators();
            this.educationForm.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm.updateValueAndValidity();
      }
    }
    else if (type == 2) {
      this.current_education2 = ev;
      if (ev) {
        this.educationForm2.controls.educationTitle.patchValue(ev.title)
        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm2.controls.passingMN.setValidators([Validators.required])
            this.educationForm2.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.passingMN.clearValidators();
            this.educationForm2.controls.passingMN.updateValueAndValidity();
          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type2 && this.current_percentage_type2.id) {
              if (this.current_percentage_type2.maxVal) {
                validators.push(Validators.max(this.current_percentage_type2.maxVal));
              }
              if (this.current_percentage_type2.minVal) {
                validators.push(Validators.min(this.current_percentage_type2.minVal));
              }
            }
            this.educationForm2.controls.percentage.setValidators(validators);
            this.educationForm2.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type2 && this.current_percentage_type2.id) {
              if (this.current_percentage_type2.maxVal) {
                validators.push(Validators.max(this.current_percentage_type2.maxVal));
              }
              if (this.current_percentage_type2.minVal) {
                validators.push(Validators.min(this.current_percentage_type2.minVal));
              }
              this.educationForm2.controls.percentage.setValidators(validators);
            }
            this.educationForm2.controls.percentage.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm2.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm2.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.specializationCode.clearValidators();
            this.educationForm2.controls.specializationCode.updateValueAndValidity();
          }
        }


        if (ev.noSpecialization) {

          this.educationForm2.controls.specializationCode.clearValidators();
          this.educationForm2.controls.specializationTitle.clearValidators();
          this.educationForm2.controls.specializationTitle.patchValue(null)
          this.educationForm2.controls.specializationCode.patchValue(null)
          this.educationForm2.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm2.controls.universityCode.setValidators([Validators.required]);
            this.educationForm2.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.universityCode.clearValidators();
            this.educationForm2.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm2.controls.collegeId.setValidators([Validators.required]);
            this.educationForm2.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.collegeId.clearValidators();
            this.educationForm2.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm2.updateValueAndValidity();
      }
    }
    else if (type == 3) {
      if (ev) {
        this.educationForm3.controls.educationTitle.patchValue(ev.title)

        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm3.controls.passingMN.setValidators([Validators.required])
            this.educationForm3.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.passingMN.clearValidators();
            this.educationForm3.controls.passingMN.updateValueAndValidity();
          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type3 && this.current_percentage_type3.id) {
              if (this.current_percentage_type3.maxVal) {
                validators.push(Validators.max(this.current_percentage_type3.maxVal));
              }
              if (this.current_percentage_type3.minVal) {
                validators.push(Validators.min(this.current_percentage_type3.minVal));
              }
            }
            this.educationForm3.controls.percentage.setValidators(validators);
            this.educationForm3.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type3 && this.current_percentage_type3.id) {
              if (this.current_percentage_type3.maxVal) {
                validators.push(Validators.max(this.current_percentage_type3.maxVal));
              }
              if (this.current_percentage_type3.minVal) {
                validators.push(Validators.min(this.current_percentage_type3.minVal));
              }
              this.educationForm3.controls.percentage.setValidators(validators);
            }
            this.educationForm3.controls.percentage.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm3.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm3.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.specializationCode.clearValidators();
            this.educationForm3.controls.specializationCode.updateValueAndValidity();
          }
        }

        if (ev.noSpecialization) {

          this.educationForm3.controls.specializationCode.clearValidators();
          this.educationForm3.controls.specializationTitle.clearValidators();
          this.educationForm3.controls.specializationTitle.patchValue(null)
          this.educationForm3.controls.specializationCode.patchValue(null)
          this.educationForm3.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm3.controls.universityCode.setValidators([Validators.required]);
            this.educationForm3.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.universityCode.clearValidators();
            this.educationForm3.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm3.controls.collegeId.setValidators([Validators.required]);
            this.educationForm3.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.collegeId.clearValidators();
            this.educationForm3.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm3.updateValueAndValidity();
      }
    }

  }
  specialicationChanged(ev, type?) {
    if (!type) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 2) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 3) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }

  }


  percentageTypeChanged(ev, type) {
    if (type == 6) {
      this.current_percentage_type = ev;
      let validators = []
      if (this.current_education && this.current_education.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm.controls.percentage.setValidators(validators);
      this.educationForm.controls.percentage.updateValueAndValidity();
    }
    else if (type == 7) {
      this.current_percentage_type2 = ev;
      let validators = []
      if (this.current_education2 && this.current_education2.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm2.controls.percentage.setValidators(validators);
      this.educationForm2.controls.percentage.updateValueAndValidity();
    }
    else if (type == 8) {
      this.current_percentage_type3 = ev;
      let validators = []
      if (this.current_education3 && this.current_education3.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm3.controls.percentage.setValidators(validators);
      this.educationForm3.controls.percentage.updateValueAndValidity();
    }
  }
  addEducation() {
    if (this.educationForm.valid) {
      let education = this.resumeBankForm.value.education;
      if (typeof education == "string") {
        try {
          education = JSON.parse(education);
          if (education && education.length) {
            let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
            if (index > -1) {
              education[index] = this.educationForm.value;
            }
            else {
              education.push(this.educationForm.value);
            }
          }
          else {
            education = []
            education.push(this.educationForm.value);
          }
        }
        catch (err) {
          education = []
        }
      } else {
        if (education && education.length) {
          let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
          if (index > -1) {
            education[index] = this.educationForm.value;
          }
          else {
            education.push(this.educationForm.value);
          }
        }
        else {
          education = []
          education.push(this.educationForm.value);
        }
      }
      this.resumeBankForm.controls.education.patchValue(education);
      this.educationForm.reset();

    }
    else {
      markFormGroupTouched(this.educationForm);
      getInvalidFields(this.educationForm, this.translate, this.notification_srv, 'RESUME.');
    }

  }
  deleteEducation(i) {

    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      panelClass: 'TM-Dialog',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_delete',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        let education = this.resumeBankForm.value.education;
        try {
          if (education && education.length) {
            education.splice(i, 1);
          }
        }
        catch (err) {
          console.log(err)
        }
        this.resumeBankForm.controls.education.patchValue(education)
      }
    })

  }

  saveChanges(panel?) {

    if (this.educationForm.value.educationLevel == 6) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
    }
    else if (this.educationForm.value.educationLevel == 7) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
      this.educationForm2.controls.educationLevel.patchValue(7)
      this.educationList.push(this.educationForm2.value)
    }
    else if (this.educationForm.value.educationLevel == 8) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
      this.educationForm2.controls.educationLevel.patchValue(7)
      this.educationForm3.controls.educationLevel.patchValue(8)
      this.educationList.push(this.educationForm2.value)
      this.educationList.push(this.educationForm3.value)
    }
    this.resumeBankForm.controls.education.patchValue(this.educationList);
  }

  editEducation(index) {
    this.educationForm.reset();
    let education = this.resumeBankForm.value.education;
    try {
      this.educationForm.patchValue(education[index]);
      if (education && education.length) {
        education.splice(index, 1);
      }
    }
    catch (err) {
      console.log(err)
    }
    this.resumeBankForm.controls.education.patchValue(education)
  }
  openSkillBottomSheet(ev?) {

    // this._bottomSheet.open(AddSkillBottomSheetComponent,{
    //   data:{skillCategoryList: this.skillCategoryList}
    // });
    let matDialogConfig = new MatDialogConfig();
    // matDialogConfig.height = "500px";
    matDialogConfig.width = "40%";
    matDialogConfig.data = {
      skillCategoryList: this.masters.skillCategoryList
    }
    matDialogConfig.panelClass = 'TM-Dialog'

    this.dialog.open(AddResumeSkillsComponent, matDialogConfig).afterClosed().subscribe(data => {

      if (data == 1) {
        // this.selectedFunction({ skillCatCode: 0 }, 1, 0, undefined);

      }
    })
  }
  fileChanged(ev) {

    if (ev) {
      if (ev && ev.result && ev.result.length) {
        this.cvAttachments = ev.result;
      }
      if (ev.parser_data) {
        if (this.registrationForm.controls.firstName.invalid || !this.registrationForm.value.firstName || this.registrationForm.value.firstName == '') {
          let info = ev.parser_data;
          if (info) {
            try {
              delete (info.cvPath)
              delete (info.cvFileName)
            }
            catch (err) {
              console.log(err)
            }
            this.registrationForm.patchValue(info);
            this.resumeBankForm.controls.totalExp.patchValue(parseInt(info.experience));
            this.resumeBankForm.controls.cvKeywords.patchValue(info.cvKeywords);
            this.resumeBankForm.controls.noticePeriod.patchValue(parseInt(info.noticePeriod));
            this.resumeBankForm.patchValue(info);
            if (this.registrationForm.value.mobileIsd == '' && this.country_info) {
              this.resumeBankForm.controls.mobileIsd.patchValue(this.country_info.defaultISD || '+91')
              this.registrationForm.controls.mobileIsd.patchValue(this.country_info.defaultISD || '+91')
            }
          }
        }
        else {
          this.dialog
            .open(ConfirmationComponent, {
              width: "480px",
              height: "auto",
              panelClass: "TM-Dialog",
              data: {
                title: "ERROR.confirmation",
                message: "RESUME.dataOverrideWarningMessage",
                positive_button: "BTN.yes",
                negative_button: "BTN.no"
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                let info = ev.parser_data;
                if (info) {
                  try {
                    delete (info.cvPath)
                    delete (info.cvFileName)
                  }
                  catch (err) {

                  }

                  this.resumeBankForm.controls.totalExp.patchValue(parseInt(info.experience));
                  this.resumeBankForm.controls.cvKeywords.patchValue(info.cvKeywords);
                  this.resumeBankForm.controls.noticePeriod.patchValue(parseInt(info.noticePeriod));
                  this.registrationForm.patchValue(info);
                }
              }
            });
        }
      }

    }
  }

  register() {

    console.log(this.registrationForm.value.password);
    console.log(this.registrationForm.value.confirmPassword);
    console.log(this.registrationForm.value);

    if (this.registrationForm.valid) {
      if (this.field_config_access && this.field_config_access['RES_captcha']) {
        if (this.valid_captcha_flag) {
          if (this.companySettingsSettings && (this.companySettingsSettings.enableEmailOtpForJS || this.companySettingsSettings.enableSmsOtpForJS)) {
            let req = this.registrationForm.value;
            let form: UntypedFormGroup = new UntypedFormGroup({
              "mobileNumber": new UntypedFormControl(null),
              "mobileIsd": new UntypedFormControl(null),
              "emailId": new UntypedFormControl(null),
              "employeeId": new UntypedFormControl(null),
              "loginId": new UntypedFormControl(null),
              "existingUser": new UntypedFormControl(null),
              "isCVMine": new UntypedFormControl(null),
              "isICR": new UntypedFormControl(0),
              "ip": new UntypedFormControl(null),
            })
            form.patchValue(this.registrationForm.value)
            if (getIP()) {
              form.controls.ip.patchValue(getIP()['ip']);
            }


            this.registration_srv.sendOTP(form.value).subscribe(res => {
              if (res && res['status'] && res['data']) {
                if (res['data'].existingUser || res['data'].userExists) {
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: 'TM-Dialog',
                    data: {
                      success: 0,
                      url: 'login',
                      url_title: "Login",
                      message: res && res['message']

                    }
                  })
                  this.notification_srv.error(res['message'], 'Close', 5000);
                }
                else {
                  this.notification_srv.success(res['message'], 'Close', 5000);
                  this.dialog.open(RegistrationOtpComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",
                    data: {
                      value: this.registrationForm.value,
                      message: res['message']
                    },
                    disableClose: true
                  }).afterClosed().subscribe(res => {
                    if (res) {
                      this.registrationForm.controls.otp.patchValue(res.otp);
                      let request = this.registrationForm.value;
                      let param = Object.assign({}, this.activated_router.snapshot.queryParams);
                      if (param) {
                        Object.keys(param).forEach(k => {
                          request[k] = param[k]
                        })
                      }
                      this.registration_srv.saveRegistration(request).subscribe(res => {
                        if (res && res['status'] && res['data']) {

                          this.notification_srv.success(res['message'], 'Close', 5000, 1);
                          if (res['data'].userDetails) {
                            this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                            this.resId = parseInt(res['data'].userDetails.resId);
                          }
                          if (res['data'].token) {
                            this.stepper_list.forEach(data => {
                              if (data.id == 1) {
                                data.disabled = 1;
                              }
                              else {
                                data.disabled = 0;
                              }
                            })
                            this.session_obj.setUserDetails({
                              firstName: this.registrationForm.value.firstName,
                              lastName: this.registrationForm.value.lastName,
                              token: res['data'].token,
                              secretKey: res['data'].secretKey,
                              resId: this.resumeBankForm.value.resId,
                              emailId: this.resumeBankForm.value.emailId,
                              mobileIsd: this.resumeBankForm.value.mobileIsd,
                              mobileNumber: this.resumeBankForm.value.mobileNumber
                            }
                            )
                            this.session.setUserDetails(this.session_obj.getUserDetails());
                            this.loadResumeWithMasters(this.resumeBankForm.value.resId);

                          }
                          setTimeout(() => {
                            this.stepper.next();
                          }, 100)
                          this.dialog.open(SuccessModalComponent, {
                            width: '40%',
                            panelClass: "TM-Dialog",

                            data: {
                              success: 1,
                              message: res && res['message']
                            }
                          })
                        }
                        else {
                          this.dialog.open(SuccessModalComponent, {
                            width: '40%',
                            panelClass: "TM-Dialog",

                            data: {
                              success: 0,
                              url: 'login',
                              url_title: "Login",
                              message: res && res['message']

                            }
                          })
                          this.notification_srv.error(res['message'], 'Close', 5000);
                        }
                      })
                    }
                  })
                }

              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000);

              }
            })

          }
          else {
            let request = this.registrationForm.value;
            let param = Object.assign({}, this.activated_router.snapshot.queryParams);
            if (param) {
              Object.keys(param).forEach(k => {
                request[k] = param[k]
              })
            }
            this.registration_srv.saveRegistration(request).subscribe(res => {
              if (res && res['status'] && res['data']) {

                if (res['data'].existingUser || res['data'].userExists) {
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",

                    data: {
                      success: 0,
                      url: 'login',
                      url_title: "Login",
                      message: res && res['message']

                    }
                  })
                  this.notification_srv.error(res['message'], 'Close', 5000);
                }
                else {
                  this.notification_srv.success(res['message'], 'Close', 5000, 1);
                  this.stepper.next();
                  if (res['data'].userDetails) {
                    this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                    this.resId = parseInt(res['data'].userDetails.resId);
                    this.editable = true
                  }
                  if (res['data'].token) {
                    this.stepper_list.forEach(data => {
                      if (data.id == 1) {
                        data.disabled = 1;
                      }
                      else {
                        data.disabled = 0;
                      }
                    })
                    this.session_obj.setUserDetails({
                      firstName: this.registrationForm.value.firstName,
                      lastName: this.registrationForm.value.lastName,
                      token: res['data'].token,
                      secretKey: res['data'].secretKey,
                      resId: this.resumeBankForm.value.resId,
                      emailId: this.resumeBankForm.value.emailId,
                      mobileIsd: this.resumeBankForm.value.mobileIsd,
                      mobileNumber: this.resumeBankForm.value.mobileNumber
                    }
                    )
                    this.session.setUserDetails(this.session_obj.getUserDetails());

                    this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                  }
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",

                    data: {
                      success: 1,
                      message: res && res['message']
                    }
                  })
                }


              }
              else {
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 0,
                    url: 'login',
                    url_title: "Login",
                    message: res && res['message']

                  }
                })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
            })
          }
        }
        else {
          if (!this.valid_captcha_flag && this.registrationForm.valid) {
            this.notification_srv.error('ERROR.verify_captcha', 'Close', 5000)
          }
        }
      }
      else {
        if (this.companySettingsSettings && (this.companySettingsSettings.enableEmailOtpForJS || this.companySettingsSettings.enableSmsOtpForJS)) {
          let req = this.registrationForm.value;
          let form: UntypedFormGroup = new UntypedFormGroup({
            "mobileNumber": new UntypedFormControl(null),
            "mobileIsd": new UntypedFormControl(null),
            "emailId": new UntypedFormControl(null),
            "employeeId": new UntypedFormControl(null),
            "loginId": new UntypedFormControl(null),
            "existingUser": new UntypedFormControl(null),
            "isCVMine": new UntypedFormControl(null),
            "isICR": new UntypedFormControl(0),
            "ip": new UntypedFormControl(null),
          })
          form.patchValue(this.registrationForm.value)
          if (getIP()) {
            form.controls.ip.patchValue(getIP()['ip']);
          }
          this.registration_srv.sendOTP(form.value).subscribe(res => {
            if (res && res['status'] && res['data']) {
              if (res['data'].existingUser || res['data'].userExists) {
                // console.log(res['message']);
                // this.dialog.open(SuccessModalComponent, {
                //   width: '40%',
                //   panelClass: 'TM-Dialog',
                //   data: {
                //     success: 0,
                //     url: 'login',
                //     url_title: "Login",
                //     message: res && res['message']

                //   }
                // })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000);
                this.dialog.open(RegistrationOtpComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",
                  data: {
                    value: this.registrationForm.value,
                    message: res['message']
                  },
                  disableClose: true
                }).afterClosed().subscribe(res => {
                  if (res) {
                    this.registrationForm.controls.otp.patchValue(res.otp);
                    let request = this.registrationForm.value;
                    let param = Object.assign({}, this.activated_router.snapshot.queryParams);
                    if (param) {
                      Object.keys(param).forEach(k => {
                        request[k] = param[k]
                      })
                    }
                    this.registration_srv.saveRegistration(request).subscribe(res => {
                      if (res && res['status'] && res['data']) {
                        this.dialog.open(SuccessModalComponent, {
                          width: '40%',
                          panelClass: "TM-Dialog",

                          data: {
                            success: 1,
                            message: res && res['message']
                          }
                        })
                        this.notification_srv.success(res['message'], 'Close', 5000, 1);
                        // this.stepper.next();
                        if (res['data'].userDetails) {
                          this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                          this.resId = parseInt(res['data'].userDetails.resId);
                        }
                        if (res['data'].token) {
                          this.stepper_list.forEach(data => {
                            if (data.id == 1) {
                              data.disabled = 1;
                            }
                            else {
                              data.disabled = 0;
                            }
                          })
                          this.session_obj.setUserDetails({
                            firstName: this.registrationForm.value.firstName,
                            lastName: this.registrationForm.value.lastName,
                            token: res['data'].token,
                            secretKey: res['data'].secretKey,
                            resId: this.resumeBankForm.value.resId,
                            emailId: this.resumeBankForm.value.emailId,
                            mobileIsd: this.resumeBankForm.value.mobileIsd,
                            mobileNumber: this.resumeBankForm.value.mobileNumber
                          }
                          )
                          this.session.setUserDetails(this.session_obj.getUserDetails());

                          this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                        }
                        setTimeout(() => {
                          this.stepper.next();
                        }, 100)
                      }
                      else {
                        this.dialog.open(SuccessModalComponent, {
                          width: '40%',
                          panelClass: "TM-Dialog",

                          data: {
                            success: 0,
                            url: 'login',
                            url_title: "Login",
                            message: res && res['message']

                          }
                        })
                        this.notification_srv.error(res['message'], 'Close', 5000);
                      }
                    })
                  }
                })
              }

            }
            else {
              this.notification_srv.success(res['message'], 'Close', 5000);

            }
          })

        }
        else {
          let request = this.registrationForm.value;
          let param = Object.assign({}, this.activated_router.snapshot.queryParams);
          if (param) {
            Object.keys(param).forEach(k => {
              request[k] = param[k]
            })
          }
          this.registration_srv.saveRegistration(request).subscribe(res => {
            if (res && res['status'] && res['data']) {

              if (res['data'].existingUser || res['data'].userExists) {
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 0,
                    url: 'login',
                    url_title: "Login",
                    message: res && res['message']

                  }
                })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000, 1);
                this.stepper.next();
                if (res['data'].userDetails) {
                  this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                  this.resId = parseInt(res['data'].userDetails.resId);
                  this.editable = true
                }
                if (res['data'].token) {
                  this.stepper_list.forEach(data => {
                    if (data.id == 1) {
                      data.disabled = 1;
                    }
                    else {
                      data.disabled = 0;
                    }
                  })
                  this.session_obj.setUserDetails({
                    firstName: this.registrationForm.value.firstName,
                    lastName: this.registrationForm.value.lastName,
                    token: res['data'].token,
                    secretKey: res['data'].secretKey,
                    resId: this.resumeBankForm.value.resId,
                    emailId: this.resumeBankForm.value.emailId,
                    mobileIsd: this.resumeBankForm.value.mobileIsd,
                    mobileNumber: this.resumeBankForm.value.mobileNumber
                  }
                  )
                  this.session.setUserDetails(this.session_obj.getUserDetails());

                  this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                }
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 1,
                    message: res && res['message']
                  }
                })
              }


            }
            else {
              this.dialog.open(SuccessModalComponent, {
                width: '40%',
                panelClass: "TM-Dialog",

                data: {
                  success: 0,
                  url: 'login',
                  url_title: "Login",
                  message: res && res['message']

                }
              })
              this.notification_srv.error(res['message'], 'Close', 5000);
            }
          })
        }
      }
      // this.registrationForm.controls.latitude.patchValue(this.lat);
      // this.registrationForm.controls.longitude.patchValue(this.lang);



    }
    else {
      this.checkFormValidation = 1;
      getInvalidFieldsV2(this.registrationForm, this.translate, this.notification_srv, 'RESUME.');
      // getInvalidFieldsV2(this.registrationForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
      markFormGroupTouched(this.registrationForm);
      this.scrollToError();
    }


  }

  loadResumeWithMasters(resId) {
    this.field_loading = true;
    this.registration_srv.getResumeDetailsWithMaster({
      resId: resId,
      sellerShortCode: environment.SHORTCODE
    }).subscribe(res => {
      if (res && res['data']) {
        this.masters = res['data'];
        console.log(this.masters)
        if (this.masters && this.masters.extendedMasterList) {
          this.masters.extendedMasterList = jsonParse(this.masters.extendedMasterList)
        }
        if (this.masters && this.masters.educationList && this.masters.educationList.length) {
          this.prepareEducationList(this.masters.educationList)
        }
        else {
          this.educationLevel1 = [];
          this.educationLevel2 = [];
          this.educationLevel3 = [];
        }
        if (res['data'].resumeDetails) {
          let data = jsonDeepParse(res['data'].resumeDetails);

          if (data && data.presentAddress) {
            this.presentAddressForm.patchValue(data.presentAddress)
          }
          if (data && data.permanentAddress) {
            this.permanentAddressForm.patchValue(data.permanentAddress)
          }

          res['data'].resumeDetails = jsonDeepParse(res['data'].resumeDetails);
          this.resume_details = res['data'].resumeDetails;
          if (res['data'].resumeDetails && res['data'].resumeDetails.keySkills && res['data'].resumeDetails.keySkills.length) {
            this.jobseeker.selected_skills = [...res['data'].resumeDetails.keySkills];
            this.key_skills_masters.skills = [...res['data'].resumeDetails.keySkills];
            res['data'].resumeDetails.keySkills = res['data'].resumeDetails.keySkills.map(d => d.id);
          }
          if (this.resume_details.industry && this.resume_details.industry.length) {
            this.resumeBankForm.controls.industryCodes.patchValue(this.resume_details.industry.map(data => data.industryCode))
          }
          this.registrationForm.patchValue(data)
          this.resumeBankForm.patchValue(data);
          if (data && data.preferredLocation && data.preferredLocation.length) {
            let ids = data.preferredLocation.map(data => data.id);
            this.resumeBankForm.controls.preferredLocationIds.patchValue(ids);
          }
          this.educationList = data.education;
          if (this.educationList && this.educationList.length) {
            for (let i = 0; i < this.educationList.length; i++) {
              let item = this.educationList[i];
              if (i == 0) {
                item.educationLevel = 6
                this.educationForm.patchValue(item);
              }
              else if (i == 1) {
                item.educationLevel = 7;
                this.educationForm2.patchValue(item)
              }
              else if (i == 2) {
                item.educationLevel = 8;
                this.educationForm3.patchValue(item)
              }
            }
            if (this.educationList.length == 1) {
              this.educationForm.controls.educationLevel.patchValue(6)
            }
            else if (this.educationList.length == 2) {
              this.educationForm.controls.educationLevel.patchValue(7)
            }
            else if (this.educationList.length == 3) {
              this.educationForm.controls.educationLevel.patchValue(8)
            }
          }
          this.onCandidateRatingChanged(data.cvRating);
          this.commRating(data.commSkillRating)
          if (data && data.cvPath && data.cvPath != '') {
            this.cvAttachments = [{
              cvPath: data.cvPath,
              cvFileName: data.cvFileName
            }]
          }
          this.registrationForm.controls.address.patchValue(data.presentLocation);
          if (data && data.extendedData) {
            data.extendedData = jsonDeepParse(data.extendedData)
            this.resumeBankForm.controls.extendedDataUI.patchValue(data.extendedData)
          }
        }
        this.field_loading = false;
      }
    }, err => {
      this.field_loading = false;
    })

  }
  prepareEducationList(data) {
    if (data && data.length) {
      this.educationLevel1 = data.filter(data => data.educationLevel == 6);
      this.educationLevel2 = data.filter(data => data.educationLevel == 7);
      this.educationLevel3 = data.filter(data => data.educationLevel == 8);
    }
  }

  addLocation() {
    let locations = this.resumeBankForm.value.preferredLocation || [];
    if (locations && locations.length) {
      if (this.current_preferred_location) {
        locations.push(this.current_preferred_location);
        this.resumeBankForm.controls.preferredLocation.patchValue(locations);
        this.google_search = ''
      }
      else {
        this.notification_srv.error('Please select valid location', 'Close', 5000)
      }
    }
    else {
      if (this.current_preferred_location) {
        locations = [this.current_preferred_location];
        this.resumeBankForm.controls.preferredLocation.patchValue(locations);
        this.google_search = ''
      }
      else {
        this.notification_srv.error('Please select valid location', 'Close', 5000)
      }
    }

  }
  parseData(data) {
    data.abilities = jsonParse(data.abilities)
    data.consultants = jsonParse(data.consultants);
    data.education = jsonParse(data.education);
    data.industry = jsonParse(data.industry);
    data.jobType = jsonParse(data.jobType);
    data.keySkills = jsonParse(data.keySkills);
    data.languages = jsonParse(data.languages);
    data.preferredLocation = jsonParse(data.preferredLocation);
    data.roles = jsonParse(data.roles);
    data.workPermits = jsonParse(data.workPermits);
    return data;
  }

  onCandidateRatingChanged(rating) {
    if (rating) {
      try {
        this.cv_rating = rating;
        if (this.masters.cvRatingLevels && this.masters.cvRatingLevels.length) {
          this.cv_rating_title = this.masters.cvRatingLevels[rating - 1].title;
        }
      }
      catch (err) {

      }

    }
  }
  commRating(rating) {

    if (rating) {
      try {
        this.comm_rating = rating;
        if (this.masters.commSkillRatingLevels && this.masters.commSkillRatingLevels.length) {
          this.comm_rating_title = this.masters.commSkillRatingLevels[rating - 1].title;
        }
      }
      catch (err) {

      }

    }
  }
  openGuidelineCommunication() {
    let matDialogConfig = new MatDialogConfig();
    // matDialogConfig.height = "500px";
    matDialogConfig.width = "60%";
    matDialogConfig.data = {
    }
    matDialogConfig.panelClass = "TM-Dialog";
    this.dialog.open(CommunicationGuidelineComponent, matDialogConfig).afterClosed().subscribe(data => {
      if (data && data.length) {

      }
    })
  }
  openGuideline() {
    let matDialogConfig = new MatDialogConfig();
    // matDialogConfig.height = "500px";
    matDialogConfig.width = "60%";
    matDialogConfig.data = {
    }
    matDialogConfig.panelClass = 'TM-Dialog'

    this.dialog.open(GuidelinesComponent, matDialogConfig).afterClosed().subscribe(data => {
      if (data && data.length) {

      }
    })
  }
  checkEducationFormValidation() {
    if (this.educationForm.invalid) {
      getInvalidFields(this.educationForm, this.translate, this.notification_srv, 'RESUME.')
      markFormGroupTouched(this.educationForm);
      return;
    }
    if (this.educationForm.valid) {
      this.active(this.stepper_list[2]);
    }
  }

  checkEducationValidation(errMsg?) {
    if (this.field_config_access && this.field_config_access['RES_education']) {
      if (this.educationForm.value.educationLevel == 6) {
        if (this.educationForm.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;
            markFormGroupTouched(this.educationForm);
          }

          return 0
        }
        else {
          return 1
        }
      }
      else if (this.educationForm.value.educationLevel == 7) {
        if (this.educationForm.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;

            markFormGroupTouched(this.educationForm)
          }

          return 0
        }
        else if (this.educationForm2.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm2, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;
            markFormGroupTouched(this.educationForm2)
          }

          return 0
        }
        else {
          return 1
        }
      }
      else if (this.educationForm.value.educationLevel == 8) {
        if (this.educationForm.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;
            markFormGroupTouched(this.educationForm)
          }

          return 0
        }
        else if (this.educationForm2.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm2, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;
            markFormGroupTouched(this.educationForm2)
          }

          return 0
        }
        else if (this.educationForm3.invalid) {
          if (errMsg) {
            getInvalidFieldsV2(this.educationForm3, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
            this.jobseeker.active = 3;
            markFormGroupTouched(this.educationForm3)
          }

          return 0
        }
        else {
          return 1
        }
      }
      else {
        return 1
      }
    }
    else {
      return 1;
    }
  }

  saveResume() {
    this.saveChanges()
    if (this.registrationForm.valid && this.resumeBankForm.valid) {
      this.resumeBankForm.patchValue(this.registrationForm.value);
      let request = {};
      request = this.resumeBankForm.value;
      request['presentLocation'] = this.registrationForm.value.address;
      if (this.resumeBankForm.value.extendedData && this.resumeBankForm.value.extendedData.length) {
        request['extendedData'] = jsonParse(this.resumeBankForm.value.extendedData);
        if (request['extendedData'] && request['extendedData'].length) {
          for (let i = 0; i < request['extendedData'].length; i++) {
            let item = request['extendedData'][i];
            if (item.mandatory && item.refType != 1 && !item.value) {
              this.notification_srv.error(item.refLabel ? ((item.refLabel || '') + ' is mandatory') : "ERROR.please_fill_mandatory_fields", 'Close', 5000);
              return;
            }
          }
        }
      }

      let params = Object.assign({}, this.activated_router.snapshot.queryParams);
      if (params) {
        try {
          Object.keys(params).forEach(k => {
            request[k] = params[k]
          })
        }
        catch (err) {
          console.log(err)
        }

      }
      console.log(request)

      if (this.field_config_access && this.field_config_access['RES_presentAddress']) {
        request['presentAddress'] = this.presentAddressForm.value;
      }
      if (this.field_config_access && this.field_config_access['RES_permanentAddress']) {
        request['permanentAddress'] = this.permanentAddressForm.value;
      }
      request['cvRating'] = this.cv_rating;
      request['commSkillRating'] = this.comm_rating;
      this.registration_srv.saveResume(request).subscribe(res => {
        if (res && res['status'] && res['data']) {
          this.notification_srv.success(res['message'], 'Close', 5000)
          if (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.productCode) {
            let productCode = this.activated_router.snapshot.queryParams.productCode;
            try {
              productCode = parseInt(this.activated_router.snapshot.queryParams.productCode)
            }
            catch (err) {
              console.log(err);
              productCode = (this.activated_router.snapshot.queryParams.productCode)
            }
            let apply_request = params || {}
            if (productCode && productCode > 0) {
              if (res['data'].resId) {
                try {
                  apply_request['resId'] = parseInt(res['data'].resId);
                }
                catch (err) {
                  console.log(err)
                  apply_request['resId'] = (res['data'].resId);
                }
              }
              apply_request['productCode'] = productCode;
              if (this.field_config_access && this.field_config_access['RES_enableConfirmationForApplyJob']) {
                this.dialog.open(ConfirmationComponent, {
                  width: '30%',
                  height: 'auto',
                  panelClass: "TM-Dialog",

                  data: {
                    title: 'CONFIRMATION.confirmation',
                    message: 'Are you sure to apply for the position',
                    message1: this.requirement_details && this.requirement_details.productName || (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.productName) || '' + ' ',
                    positive_button: 'BTN.apply',
                    negative_button: 'BTN.cancel'
                  }
                }).afterClosed().subscribe(res => {
                  if (res) {
                    this.registration_srv.applyForJob(apply_request).subscribe(res => {
                      if (res && res['status']) {
                        this.notification_srv.success(res['message'], 'Close', 5000);
                        if (productCode && productCode > 0) {
                          this.router.navigate(['job', productCode])
                        }
                        else {
                          this.router.navigate(['jobs'])
                        }
                      }
                      else {
                        this.notification_srv.error(res['message'], 'Close', 5000)
                      }
                    })
                  }
                  else {
                    if (productCode && productCode > 0) {
                      this.router.navigate(['job', productCode])
                    }
                  }
                })
              }
              else {
                this.registration_srv.applyForJob(apply_request).subscribe(res => {
                  if (res && res['status']) {
                    this.notification_srv.success(res['message'], 'Close', 5000);
                    if (productCode && productCode > 0) {
                      this.router.navigate(['job', productCode])
                    }
                    else {
                      this.router.navigate(['jobs'])
                    }
                  }
                  else {
                    this.notification_srv.error(res['message'], 'Close', 5000)
                  }
                })
              }

            }

            else if (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.job) {
              let productCode = this.activated_router.snapshot.queryParams.job;
              try {
                productCode = parseInt(this.activated_router.snapshot.queryParams.job)
              }
              catch (err) {
                console.log(err);
                productCode = (this.activated_router.snapshot.queryParams.job)
              }
              let apply_request = params || {}
              if (productCode && productCode > 0) {
                if (res['data'].resId) {
                  try {
                    apply_request['resId'] = parseInt(res['data'].resId);
                  }
                  catch (err) {
                    console.log(err)
                    apply_request['resId'] = (res['data'].resId);
                  }
                }
                apply_request['productCode'] = productCode;
                if (this.field_config_access && this.field_config_access['RES_enableConfirmationForApplyJob']) {
                  this.dialog.open(ConfirmationComponent, {
                    width: '30%',
                    height: 'auto',
                    panelClass: "TM-Dialog",

                    data: {
                      title: 'CONFIRMATION.confirmation',
                      message: 'Are you sure to apply for the position',
                      message1: this.requirement_details && this.requirement_details.productName || (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.productName) || '' + ' ',
                      positive_button: 'BTN.apply',
                      negative_button: 'BTN.cancel'
                    }
                  }).afterClosed().subscribe(res => {
                    if (res) {
                      this.registration_srv.applyForJob(apply_request).subscribe(res => {
                        if (res && res['status']) {
                          this.notification_srv.success(res['message'], 'Close', 5000);
                          if (productCode && productCode > 0) {
                            this.router.navigate(['job', productCode])
                          }
                          else {
                            this.router.navigate(['jobs'])
                          }
                        }
                        else {
                          this.notification_srv.error(res['message'], 'Close', 5000)
                        }
                      })
                    }
                    else {
                      if (productCode && productCode > 0) {
                        this.router.navigate(['job', productCode])
                      }
                    }
                  })
                }
                else {
                  this.registration_srv.applyForJob(apply_request).subscribe(res => {
                    if (res && res['status']) {
                      this.notification_srv.success(res['message'], 'Close', 5000);
                      if (productCode && productCode > 0) {
                        this.router.navigate(['job', productCode])
                      }
                      else {
                        this.router.navigate(['jobs'])
                      }
                    }
                    else {
                      this.notification_srv.error(res['message'], 'Close', 5000)
                    }
                  })
                }
              }
              else {
                this.router.navigate(['jobs']);
              }
            }
          }
          else if (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.job) {
            let productCode = this.activated_router.snapshot.queryParams.job;
            try {
              productCode = parseInt(this.activated_router.snapshot.queryParams.job)
            }
            catch (err) {
              console.log(err);
              productCode = (this.activated_router.snapshot.queryParams.job)
            }
            let apply_request = params || {}
            if (productCode && productCode > 0) {
              if (res['data'].resId) {
                try {
                  apply_request['resId'] = parseInt(res['data'].resId);
                }
                catch (err) {
                  console.log(err)
                  apply_request['resId'] = (res['data'].resId);
                }
              }
              apply_request['productCode'] = productCode;
              if (this.field_config_access && this.field_config_access['RES_enableConfirmationForApplyJob']) {
                this.dialog.open(ConfirmationComponent, {
                  width: '30%',
                  height: 'auto',
                  panelClass: "TM-Dialog",

                  data: {
                    title: 'CONFIRMATION.confirmation',
                    message: 'Are you sure to apply for the position',
                    message1: this.requirement_details && this.requirement_details.productName || (this.activated_router.snapshot.queryParams && this.activated_router.snapshot.queryParams.productName) || '' + ' ',
                    positive_button: 'BTN.apply',
                    negative_button: 'BTN.cancel'
                  }
                }).afterClosed().subscribe(res => {
                  if (res) {
                    this.registration_srv.applyForJob(apply_request).subscribe(res => {
                      if (res && res['status']) {
                        this.notification_srv.success(res['message'], 'Close', 5000);
                        if (productCode && productCode > 0) {
                          this.router.navigate(['job', productCode])
                        }
                        else {
                          this.router.navigate(['jobs'])
                        }
                      }
                      else {
                        this.notification_srv.error(res['message'], 'Close', 5000)
                      }
                    })
                  }
                  else {
                    if (productCode && productCode > 0) {
                      this.router.navigate(['job', productCode])
                    }
                  }
                })
              }
              else {
                this.registration_srv.applyForJob(apply_request).subscribe(res => {
                  if (res && res['status']) {
                    this.notification_srv.success(res['message'], 'Close', 5000);
                    if (productCode && productCode > 0) {
                      this.router.navigate(['job', productCode])
                    }
                    else {
                      this.router.navigate(['jobs'])
                    }
                  }
                  else {
                    this.notification_srv.error(res['message'], 'Close', 5000)
                  }
                })
              }
            }
            else {
              this.router.navigate(['jobs']);
            }
          }
          else {
            this.router.navigate(['jobs']);
          }
        }
        else {
          if (res) {
            try {
              if (res['message'] == 'Education is mandatory') {
                this.notification_srv.error(res['message'], 'CLose', 5000);
                this.currentIndex = 1;
                return;
              }
            }
            catch (err) {
              this.notification_srv.error(res['message'], 'CLose', 5000)
              return;
            }

            this.notification_srv.error(res['message'], 'CLose', 5000)
          }
          else {
            this.notification_srv.error('Something went wrong please try again after sometime', 'CLose', 5000)
          }
        }
      })
    }
    else {
      getInvalidFieldsV2(this.resumeBankForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
      markFormGroupTouched(this.resumeBankForm);
      this.scrollToError()
    }


  }

  login() {
    if (this.resId) {
      this.router.navigate(['jobs'])
    }
    else {
      const dialog = this.dialog.open(LoginComponentV2, {
        width: '500px',
        disableClose: true,
        panelClass: "TM-Dialog",

      });
      dialog.afterClosed().subscribe(result => {

      });
    }

  }

  setupDevices(obj) {
    console.log(obj);
    if (!this.profileCaptureStarted) {
      this.notification_srv.success('Please wait while video device is being initializing', 'Close', 5000)
      let out_obj = {
        screenCapture: '',
        error: 'You have no output video device',
        camCapture: '',
        id: 0,
        status: 1
      };
      let width = 400;
      let height = 0;
      let streaming = false;
      let camera = document.getElementById('camera');
      let video: any = document.getElementById('video');
      let startbutton = document.getElementById('startbutton');
      let cancelButton = document.getElementById('cancelButton');
      // camera.appendChild(video)
      // camera.appendChild(cancelButton)
      // camera.appendChild(startbutton)
      video.autoplay = true;

      let canvas = document.createElement('canvas');
      if (obj.isCamShot) {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          this.profileCaptureStarted = true;
          try {
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
              if (stream) {
                video.srcObject = stream;
                video.play();
                video.addEventListener('canplay', ev => {
                  camera.classList.add('d-flex')
                  if (!streaming) {
                    height = video.videoHeight / (video.videoWidth / width);
                    if (isNaN(height)) {
                      height = width / (4 / 3);
                    }
                    video.setAttribute('width', width.toString());
                    video.setAttribute('height', height.toString());
                    canvas.setAttribute('width', width.toString());
                    canvas.setAttribute('height', height.toString());
                    streaming = true;
                    // var context = canvas.getContext('2d');
                    // canvas.width = width;
                    // canvas.height = height;
                    // context.drawImage(video, 0, 0, width, height);
                    // let img = canvas.toDataURL('image/png');
                    // out_obj.camCapture = img;
                    // stream.getTracks().forEach(function (track) {
                    //   track.stop();
                    // });
                    // video.remove();
                    // canvas.remove();
                    // this.getCDNPath(out_obj)

                  }
                }, false);
                startbutton.addEventListener('click', ev => {
                  var context = canvas.getContext('2d');
                  canvas.width = width;
                  canvas.height = height;
                  context.drawImage(video, 0, 0, width, height);
                  let img = canvas.toDataURL('image/png');
                  out_obj.camCapture = img;

                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  // startbutton.remove();
                  this.getCDNPath(out_obj)
                })
                cancelButton.addEventListener('click', ev => {
                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  // startbutton.remove();
                })
                out_obj.error = null;
              } else {
                out_obj.error = 'You have no output video device';
              }
            }).catch(err => {
              this.profileCaptureStarted = false;
              this.notification_srv.error('RESUME.please_enable_camera_permission_to_capture_photo', 'Close', 8000)
            });
          } catch (e) {
            out_obj.error = e;
          }
        }
      }
    }
    else {

    }


  }
  getCDNPath(obj) {
    console.log(obj);
    let out_obj: any = {
      "id": 0,
      "status": 1,
      "screenCapture": [],
      "camCapture": []
    }

    if (out_obj.camCapture) {
      this.registration_srv.getCDNPath('camCapture.png', obj.camCapture).subscribe(camCapture => {
        let c: any = camCapture;
        if (c && c.length) {
          console.log(c[0]);
          this.registrationForm.controls.profilePicture.patchValue(c[0].cdnPath);
          this.resumeObj.profilePicture = c[0].cdnPath;
        }
      })
    }
  }
  viewAttachments(item) {
    viewDocument(item.attachments, item.attachments[0], this.dialog, null, 'fileName', 'cdnPath');
  }

  removeUploadedFile() {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "TM-Dialog",
        data: {
          title: "ERROR.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
          positive_button: "BTN.yes",
          negative_button: "BTN.no"
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.uploadedImageUrl = ''
          this.resumeObj.profilePicture = '';
          this.registrationForm.controls['profilePicture'].setValue('')
        }
      });

    // this.el.nativeElement.files = []
    // this.el.nativeElement.remove();

    // this.registrationForm.patchValue({
    //   file: [null]
    // });
  }

  fileInputChanged(event) {

    console.log(event);

    let reader = new FileReader();
    let file = event.target.files[0];
    console.log(file);
    // if (file) {
    //   this.result = Object.assign([], file || []);
    //   this.returnFiles.emit({ files: this.result, source: this.flag })
    // }
    // this.profilePhoto = this.dataURItoBlob(file, undefined, undefined);

    this.file_service.convertFilesToBase64(event.target.files).subscribe(res => {
      // this.selected_files = res as any;

      //   this.result = this.selected_files;

    })
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadedImageUrl = reader.result;
        // this.registrationForm.patchValue({
        //   file: reader.result
        // });
      }

      this.change_detector.markForCheck();
    }

    // this.result = [];
    // this.parsingInProgress = true;
    // this.hideUploadButton = true;
    // this.imageChangedEvent = files;
  }


  copyMobileNumberToWA() {
    this.registrationForm.controls.waMobileIsd.patchValue(this.registrationForm.value.mobileIsd);
    this.registrationForm.controls.waMobileNumber.patchValue(this.registrationForm.value.mobileNumber);
  }

  applyReferralCode() {
    this.registration_srv.applyReferralCode({
      referralCode: this.registrationForm.value.referralCode
    }).subscribe(res => {
      this.referral_code.isVerify = true;
      if (res && res['status'] && res['data']) {
        this.referral_code.isValid = true;
        if (res['data'].referredUserList && res['data'].referredUserList.length) {
          let data = res['data'].referredUserList[0];
          this.referral_code.displayName = data.displayName
          this.referral_code.referralCode = data.membershipId
        }

      }
      else {
        if (res) {
          this.referral_code.message = res['message']

        }
      }
    })
  }
  declinePolicy() {
    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      panelClass: "TM-Dialog",

      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_close',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.router.navigate(['home'])
      }
    })
  }
  acceptPolicy(step?) {
    if (!step) {
      this.steps[0] = 0;
      this.steps[1] = 1;
    }
    else if (step == 2) {
      this.steps[0] = 0;
      this.steps[1] = 0;
      this.steps[step] = 1;
      setTimeout(() => {
        this.addRecaptchaScript()
      })
    }
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }
  renderReCaptch() {
    try {
      window['grecaptcha'].render('tm-recaptcha', {
        'sitekey': environment.RECAPCHA_KEY,
        'callback': (response) => {
          this.valid_captcha = response;
          this.valid_captcha_flag = true;
          this.change_detector.detectChanges();
        },
        'expired-callback': (response) => {
          this.expiredCallback();
        },
      });
    }
    catch (err) {
      try {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha', {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
      catch (err) {
        setTimeout(() => {
          window['grecaptcha'].render('tm-recaptcha' || this.captch_element && this.captch_element.nativeElement, {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
    }

  }
  expiredCallback() {
    this.valid_captcha = "";
    this.valid_captcha_flag = false
    this.change_detector.detectChanges();

  }
  presentMultiLocationChanged(ev) {

    this.resumeBankForm.controls.preferredLocation.patchValue(ev)
  }
  nextStep(cStep?) {
    this.resumeBankForm.patchValue(this.registrationForm.value)
    if (cStep == 2) {
      this.secondTabFormGroup.patchValue(this.resumeBankForm.value);
      if (this.secondTabFormGroup.valid) {
        let validEd = this.checkEducationValidation(1)
        if (validEd) {
          this.stepper.next()
        }
      }
      else {
        markFormGroupTouched(this.resumeBankForm)
        getInvalidFieldsV2(this.secondTabFormGroup, this.translate, this.notification_srv, 'RESUME.', null, this.field_config_access, 'RES_')
        this.scrollToError();
      }
    }
    else if (cStep == 1) {
      if (this.registrationForm.valid) {
        this.stepper.next()
      }
      else {
        markFormGroupTouched(this.registrationForm)
        getInvalidFieldsV2(this.registrationForm, this.translate, this.notification_srv, 'RESUME.', null, this.field_config_access, 'RES_')
        this.scrollToError();
      }
    }
    console.log(this.currentIndex)
  }
  previousStep(cStep?) {
    // cStep.previous();
    this.change_detector.detectChanges()
  }
  preferredJobTypeChanges(ev) {
    console.log(ev)
    if (ev && ev.length) {
      let maxAge = ev.reduce((acc, curr) => {
        if (curr.minAge > acc) {
          acc = curr.minAge;
        }
        return acc
      }, 0)
      this.startAt = new Date();
      this.startAt.setFullYear(this.startAt.getFullYear() - maxAge)
    }
    else {
      this.startAt = new Date();
      this.startAt.setFullYear(this.startAt.getFullYear() - 15)
    }
  }
  randomNumber() {
    return Math.floor(Math.random() * (100) + 80);
  }
  openLink(type?) {
    // if (type == 2) {
    //   this.dialog.open(LinkPopupComponent, {
    //     width: '60%',
    //     data: {
    //       title: "EXTRA.pp",
    //       link: 'https://cvmine.com/cvmine-privacy-policy.html'
    //     }
    //   })
    // }
    // else if (type == 1) {
    //   this.dialog.open(LinkPopupComponent, {
    //     width: '60%',
    //     data: {
    //       title: "EXTRA.tou",
    //       link: 'https://cvmine.com/cvmine-terms-of-use.html'
    //     }
    //   })
    // }

  }
  checkboxEvent(ev, control) {
    this.resumeBankForm.controls[control].patchValue(ev.checked ? 1 : 0);
    console.log(this.resumeBankForm.controls[control].value)

  }
  verifyCaptch(ev) {
    this.valid_captcha = ev;
    this.valid_captcha_flag = ev ? true : false;
  }
  issueDateChanged(ev) {

  }
  openDrivingLicense() {
    this.dialog.open(DrivingLicenseComponent, {
      width: '60%',
      data: {
        master_data: this.masters,
        list: this.resumeBankForm.value.drivingLicense,
        all_rights: this.all_rights ? this.all_rights.fieldConfigFlags : [],
        // country_list: this.countryList
      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res) {
        this.resumeBankForm.controls.drivingLicense.patchValue(res);
      }
    })
  }
  openNominee() {
    this.dialog.open(ResumeNomineeComponent, {
      width: '60%',
      data: {
        master_data: this.masters,
        list: this.resumeBankForm.value.nomineeItems,
        all_rights: this.all_rights ? this.all_rights.fieldConfigFlags : [],

      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res) {
        this.resumeBankForm.controls.nomineeItems.patchValue(res);
      }
    })
  }
  currencyChanged(ev, type) {
    console.log(ev)
    if (ev) {
      if (type == 1) { // present salary
        this.jobseeker.current_present_salary = ev;
        this.resumeBankForm.controls.presentSalary.patchValue(ev.value)

        if (ev.currencyId) {
          this.resumeBankForm.controls.presentSalaryCurrId.patchValue(ev.currencyId)
        }
        if (ev.scaleDurationId) {
          this.resumeBankForm.controls.presentSalaryScaleDurationId.patchValue(ev.scaleDurationId)
        }
      }
      else if (type == 2) {//expected salary
        this.jobseeker.current_expected_salary = ev;
        this.resumeBankForm.controls.expSalary.patchValue(ev.value)

        if (ev.currencyId) {
          this.resumeBankForm.controls.expSalaryCurrId.patchValue(ev.currencyId)
        }
        if (ev.scaleDurationId) {
          this.resumeBankForm.controls.expSalaryScaleDurationId.patchValue(ev.scaleDurationId)
        }
      }
      else if (type == 3) { //Notice period
        this.jobseeker.current_notice_period = ev;
        this.resumeBankForm.controls.noticePeriod.patchValue(ev.value)

      }
      else if (type == 4) { // experience
        this.jobseeker.current_experience = ev;
        this.resumeBankForm.controls.totalExp.patchValue(ev.value)

      }
      else if (type == 5) {
        this.jobseeker.current_net_salary = ev;
        this.resumeBankForm.controls.netSalary.patchValue(ev.value)

        if (ev.currencyId) {
          this.resumeBankForm.controls.netSalaryCurrId.patchValue(ev.currencyId)
        }
        if (ev.scaleDurationId) {
          this.resumeBankForm.controls.netSalarySDTemplateCode.patchValue(ev.scaleDurationId)
        }

      }
    }

  }
  openWorkExperince(id?) {
    this.dialog.open(WorkExperienceComponent, {
      width: '60%',
      data: {
        master_data: this.masters,
        list: this.resumeBankForm.value.employmentHistory,
        all_rights: this.all_rights ? this.all_rights.fieldConfigFlags : [],

        id: id
      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res) {
        console.log(res)
        this.resumeBankForm.controls.employmentHistory.patchValue(res);
      }
    })
  }
  openEmergencyContacts() {
    this.dialog.open(EmergencyContactsComponent, {
      width: '60%',
      data: {
        master_data: this.masters,
        country_list: this.country_info.countryList,
        list: this.resumeBankForm.value.emergencyContacts,
        all_rights: this.all_rights ? this.all_rights.fieldConfigFlags : [],

      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res) {
        this.resumeBankForm.controls.emergencyContacts.patchValue(res);
      }
    })

  }
  copyAddress() {
    this.permanentAddressForm.patchValue(this.presentAddressForm.value)
  }
  presentCityChanged(ev, type) {
    if (ev) {
      if (type == 1) {
        this.presentAddressForm.patchValue(ev);
      }
      else if (type == 2) {
        this.permanentAddressForm.patchValue(ev);
      }

    }
  }
  openLanguages(id?) {
    this.dialog.open(LanguageListComponent, {
      width: '80%',
      data:
      {
        languageData: this.resumeBankForm.value.languageData,
        masters: this.masters,
      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res && res.length) {
        this.resumeBankForm.controls.languageData.patchValue(res)
      }
    })
  }
  openBankDetails() {
    this.dialog.open(BankDetailsComponent, {
      width: "50%",
      minHeight: "80%",
      data: {
        resume_details: this.resumeBankForm.value,
        all_rights: this.all_rights ? this.all_rights.fieldConfigFlags : [],

        all_masters: this.masters
      },
      panelClass: 'TM-Dialog'
    }).afterClosed().subscribe(res => {
      if (res) {
        this.resumeBankForm.patchValue(res);
      }
    })
  }
  scrollTo(el: Element): void {
    setTimeout(() => {
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    })

  }
  scrollToError(): void {
    setTimeout(() => {
      const firstElementWithError = document.querySelector(
        ".mat-form-field-invalid"
      );
      this.scrollTo(firstElementWithError);
    }, 200)


  }
  openPickpoint() {
    if (this.field_config_access && this.field_config_access['RES_pickUpPoint']) {
      this.dialog.open(CvMapComponent, {
        width: '60%',
        data: {
          latitude: this.resumeBankForm.value.pickUpPoint ? this.resumeBankForm.value.pickUpPoint.latitude : null,
          longitude: this.resumeBankForm.value.pickUpPoint ? this.resumeBankForm.value.pickUpPoint.longitude : null,
          label: this.field_config_access['RES_pickUpPoint'].label || 'Location description',
          placeholder: this.field_config_access['RES_pickUpPoint'].placeholder || "Enter location description",
          enable_description: 1,
          description: this.resumeBankForm.value.pickUpPoint ? this.resumeBankForm.value.pickUpPoint.locationDesc : null,

        },
        panelClass: 'TM-Dialog'
      }).afterClosed().subscribe(res => {
        if (res) {
          this.resumeBankForm.controls.pickUpPoint.patchValue(res);
        }
      })
    }

  }
  keySkillsChanged(ev) {
    if (ev && ev.length) {
      this.jobseeker.selected_skills = ev;
    }
    else {
      this.jobseeker.selected_skills = [];
    }
  }
  loadSkills(ev) { //loading skills dynamic from backend
    console.log(ev)
    this.registration_srv.loadSkills(ev, '2').subscribe(res => {
      if (res && res['data'] && res['data'].list && res['data'].list.length) {
        if (this.jobseeker.selected_skills && this.jobseeker.selected_skills.length) {
          this.key_skills_masters.skills = [...res['data'].list, ...this.jobseeker.selected_skills]
          this.key_skills_masters.skills = removeDuplicate(this.key_skills_masters.skills, 'id')
        }
        else {
          this.key_skills_masters.skills = res['data'].list || []
        }
      }
      else {
        this.key_skills_masters.skills = [];
        this.jobseeker.no_data_found_message = "No data found!"
      }
    })
  }
  loadJobtitleList(ev) { //load job title based on search keywords
    if (ev) {
      this.registration_srv.getRequirementList({
        'search': ev.search
      }).subscribe(res => {
        if (res && res['data']) {
          if (res['data'].list && res['data'].list.length) {
            if (this.jobseeker.selected_jobtitle && this.jobseeker.selected_jobtitle.length) {
              this.jobseeker.jobTitleList = [...res['data'].list, ...this.jobseeker.selected_jobtitle];
              this.jobseeker.jobTitleList = removeDuplicate(this.jobseeker.jobTitleList, 'id')
            }
            else {
              this.jobseeker.jobTitleList = res['data'].list;

            }
          }
          else {
            this.jobseeker.jobTitleList = [];
          }

        }
      })
    }

  }

  getUniversityList(ev, type) { //load UniversityList

    this.registration_srv.getUniversityList(ev).subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        if (type == 1) {
          this.education_masters.universityList1 = res['data'].list || []
        }
        else if (type == 2) {
          this.education_masters.universityList2 = res['data'].list || []
        }
        else if (type == 3) {
          this.education_masters.universityList3 = res['data'].list || []
        }

      }


    })
  }

  getCollegeList(ev, type) { //load UniversityList

    this.registration_srv.getCollegeList(ev).subscribe(res => {
      if (res && res['data'] && res['data'].list) {
        if (type == 1) {
          this.education_masters.collegeList1 = res['data'].list || []
        }
        else if (type == 2) {
          this.education_masters.collegeList2 = res['data'].list || []
        }
        else if (type == 3) {
          this.education_masters.collegeList3 = res['data'].list || []
        }

      }

    })
  }
}
